import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => {
  return useContext(CartContext);
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      try {
        return JSON.parse(savedCart);
      } catch (error) {
        console.error('Erreur lors du chargement du panier depuis localStorage:', error);
        localStorage.removeItem('cart');
        return [];
      }
    }
    return [];
  });

  const [shippingMethod, setShippingMethod] = useState(() => {
    const savedMethod = localStorage.getItem('shippingMethod');
    return savedMethod || 'colissimo';
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    localStorage.setItem('shippingMethod', shippingMethod);
  }, [shippingMethod]);

  const addToCart = (product, quantity = 1) => {
    setCart(prevCart => {
      const existingItem = prevCart.find(item => item.id === product.id);
      if (existingItem) {
        return prevCart.map(item =>
          item.id === product.id ? { ...item, quantity: item.quantity + quantity } : item
        );
      } else {
        return [...prevCart, { ...product, quantity }];
      }
    });
  };

  const removeFromCart = (id) => {
    setCart(prevCart => prevCart.filter(item => item.id !== id));
  };

  const updateQuantity = (id, quantity) => {
    if (quantity <= 0) {
      removeFromCart(id);
    } else {
      setCart(prevCart =>
        prevCart.map(item =>
          item.id === id ? { ...item, quantity } : item
        )
      );
    }
  };

  const clearCart = () => {
    setCart([]);
  };

  const getTotal = () => {
    return cart.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  const getTotalItems = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  const getShippingCost = () => {
    if (shippingMethod === 'pickup') {
      return 0;
    }
    const totalItems = getTotalItems();
    if (totalItems >= 10) return 15;
    if (totalItems >= 6) return 9;
    if (totalItems >= 3) return 7;
    if (totalItems >= 1) return 5;
    return 0;
  };

  return (
    <CartContext.Provider value={{
      cart,
      addToCart,
      removeFromCart,
      updateQuantity,
      clearCart,
      getTotal,
      getTotalItems,
      getShippingCost,
      shippingMethod,
      setShippingMethod
    }}>
      {children}
    </CartContext.Provider>
  );
};